import airkamLogo from '../images/airkam-logo.png'
import airkamSolarLogo from '../images/airkam-solar.png'
import asmadLogo from '../images/asmad-logo.png'
import auxLogo from '../images/aux-logo.png'
import glasstechLogo from '../images/glasstech-logo.png'
import kamacioLogo from '../images/kamacio-logo.png'
import kamaltdLogo from '../images/kamaltd-logo.png'
import kamdevLogo from '../images/kamdev-logo.png'
import kamtekLogo from '../images/kamtek-logo.png'
import kamturizmLogo from '../images/kamturizm-logo.png'

export type Language = 'tr' | 'en'

export type Company = {
  id: string
  name: string
  logo: string
  accentRgb: string
  website?: string
  position: { left: string; top: string }
  sector: Record<Language, string>
  description: Record<Language, string>
}

export const companies: Company[] = [
  {
    id: 'kamtek',
    name: 'Kamtek',
    logo: kamtekLogo,
    accentRgb: '185, 32, 37',
    website: 'https://www.kam-tek.com/',
    position: { left: '50%', top: '8%' },
    sector: { tr: 'İnşaat & Yapı Sistemleri', en: 'Construction & Building Systems' },
    description: {
      tr: 'Anahtar teslim inşaat, cephe, ağır çelik, iklimlendirme ve çağdaş yapı çözümleri.',
      en: 'Turnkey construction, façades, structural steel, climate systems and modern building solutions.',
    },
  },
  {
    id: 'glasstech',
    name: 'Glasstech',
    logo: glasstechLogo,
    accentRgb: '22, 129, 65',
    website: 'https://glasstechtrading.com/',
    position: { left: '71%', top: '14%' },
    sector: { tr: 'Cam Teknolojileri', en: 'Glass Technologies' },
    description: {
      tr: 'Mimari ve endüstriyel projeler için yüksek standartlı cam üretimi ve işleme çözümleri.',
      en: 'High-standard glass production and processing solutions for architectural and industrial projects.',
    },
  },
  {
    id: 'airkam',
    name: 'Airkam Trading',
    logo: airkamLogo,
    accentRgb: '232, 75, 37',
    website: 'https://www.air-kam.com/',
    position: { left: '87.5%', top: '32%' },
    sector: { tr: 'Ticaret & İklimlendirme', en: 'Trading & Climate Systems' },
    description: {
      tr: 'Teknoloji, iklimlendirme ve dayanıklı tüketim ürünlerinde güçlü satış ve servis ağı.',
      en: 'A strong sales and service network in technology, climate systems and durable consumer goods.',
    },
  },
  {
    id: 'airkam-solar',
    name: 'Airkam Solar Systems',
    logo: airkamSolarLogo,
    accentRgb: '246, 147, 32',
    website: 'https://airkamsolar.com/',
    position: { left: '87%', top: '59%' },
    sector: { tr: 'Yenilenebilir Enerji', en: 'Renewable Energy' },
    description: {
      tr: 'Konut ve işletmeler için verimli, sürdürülebilir ve profesyonel güneş enerjisi sistemleri.',
      en: 'Efficient, sustainable and professionally installed solar energy systems for homes and businesses.',
    },
  },
  {
    id: 'kamdev',
    name: 'Kamtek Developments',
    logo: kamdevLogo,
    accentRgb: '22, 19, 65',
    website: 'https://www.kamtekdevelopments.com/',
    position: { left: '71%', top: '75%' },
    sector: { tr: 'Gayrimenkul Geliştirme', en: 'Property Development' },
    description: {
      tr: 'Kuzey Kıbrıs’ta sürdürülebilir, rafine ve uzun vadeli değer üreten yaşam alanları.',
      en: 'Sustainable, refined living spaces designed to create lasting value in Northern Cyprus.',
    },
  },
  {
    id: 'kamaltd',
    name: 'Kamacıoğlu Ltd.',
    logo: kamaltdLogo,
    accentRgb: '232, 75, 37',
    position: { left: '50%', top: '80%' },
    sector: { tr: 'Operasyon & Proje Hizmetleri', en: 'Operations & Project Services' },
    description: {
      tr: 'Grup deneyimini sahaya taşıyan, güvenilir ve sonuç odaklı operasyon çözümleri.',
      en: 'Reliable, outcome-focused operational solutions powered by the Group’s field experience.',
    },
  },
  {
    id: 'kamacioglu-dorm',
    name: 'Kamacıoğlu Öğrenci Yurdu',
    logo: kamacioLogo,
    accentRgb: '129, 41, 142',
    position: { left: '28.5%', top: '75%' },
    sector: { tr: 'Öğrenci Yaşamı', en: 'Student Living' },
    description: {
      tr: 'Öğrenciler için güvenli, konforlu ve sosyal yaşamı destekleyen çağdaş konaklama.',
      en: 'Safe, comfortable and contemporary accommodation supporting a rich student life.',
    },
  },
  {
    id: 'aux',
    name: 'AUX',
    logo: auxLogo,
    accentRgb: '185, 32, 37',
    website: 'https://www.kam-tek.com/',
    position: { left: '13%', top: '59%' },
    sector: { tr: 'İklimlendirme Teknolojileri', en: 'Climate Technologies' },
    description: {
      tr: 'Konut ve ticari yapılar için yeni nesil iklimlendirme teknolojileri ve teknik destek.',
      en: 'Next-generation climate technologies and technical support for residential and commercial spaces.',
    },
  },
  {
    id: 'kamturizm',
    name: 'Kamtek Turizm',
    logo: kamturizmLogo,
    accentRgb: '246, 147, 32',
    position: { left: '12.5%', top: '32%' },
    sector: { tr: 'Turizm & Konaklama', en: 'Tourism & Hospitality' },
    description: {
      tr: 'Kuzey Kıbrıs’ın karakterini odağına alan misafirperverlik ve turizm deneyimleri.',
      en: 'Hospitality and tourism experiences inspired by the distinctive character of Northern Cyprus.',
    },
  },
  {
    id: 'asmad',
    name: 'ASMAD',
    logo: asmadLogo,
    accentRgb: '22, 129, 65',
    website: 'https://asmad.com.tr/',
    position: { left: '29%', top: '14%' },
    sector: { tr: 'Yapı Kimyasalları', en: 'Construction Chemicals' },
    description: {
      tr: 'Yalıtım, zemin, restorasyon ve yapı uygulamaları için profesyonel malzeme çözümleri.',
      en: 'Professional material solutions for insulation, flooring, restoration and construction applications.',
    },
  },
]

export const content = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      companies: 'Şirketler',
      quality: 'Kalite',
      careers: 'Kariyer',
      contact: 'İletişim',
    },
    hero: {
      eyebrow: 'Kuzey Kıbrıs’tan geleceğe',
      title: 'Birlikte üretiyor, geleceğe değer katıyoruz.',
      description:
        'İnşaattan enerjiye, cam teknolojilerinden yaşam alanlarına uzanan güçlü ekosistemimizle sürdürülebilir değer üretiyoruz.',
      explore: 'Faaliyet ağını keşfet',
      contact: 'Bize ulaşın',
      networkLabel: 'Şirketler ve markalar ağı',
      networkHint: 'Her logoya dokunarak ilgili faaliyet alanını keşfedin.',
    },
    stats: [
      { value: '9', label: 'Grup şirketi' },
      { value: '750+', label: 'Çalışan' },
      { value: '50+', label: 'Tamamlanan büyük ölçekli kalkınma projesi' },
    ],
    about: {
      eyebrow: 'Köklü deneyim, ortak gelecek',
      title: 'Farklı uzmanlıkları aynı vizyonda buluşturuyoruz.',
      lead:
        'Kamacıoğlu Şirketler Grubu, Kuzey Kıbrıs’ın ekonomik ve toplumsal gelişimine katkı sağlayan, birbirini tamamlayan iş kollarını tek bir güçlü kültür altında bir araya getirir.',
      visionTitle: 'Vizyonumuz',
      vision:
        'Farklılıklar yaratarak sağladığımız üstünlükleri kalıcı hale getirmek ve dünya markası olma yolunda ilerlemek.',
      missionTitle: 'Misyonumuz',
      mission:
        'Faaliyet gösterdiğimiz tüm alanlarda kaliteden ödün vermeden üretmek; müşterilerimiz, çalışanlarımız ve toplum için sürdürülebilir değer yaratmak.',
      valuesTitle: 'Bizi bir arada tutan değerler',
      values: ['Güven', 'Sürekli gelişim', 'İnsan odağı', 'Toplumsal sorumluluk'],
    },
    companies: {
      eyebrow: 'Güçlü ekosistem',
      title: 'Bir merkez, birçok uzmanlık.',
      description:
        'Şirketlerimiz ve temsil ettiğimiz markalar; bilgi, deneyim ve kaynaklarını paylaşarak daha güçlü çözümler üretir.',
      visit: 'Web sitesini ziyaret et',
      profile: 'Grup profili',
    },
    quality: {
      eyebrow: 'Kalite yaklaşımımız',
      title: 'Kaliteyi bir sonuç değil, çalışma biçimi olarak görüyoruz.',
      description:
        'Her projede güvenliği, çevresel sorumluluğu ve sürekli gelişimi aynı standardın ayrılmaz parçaları olarak ele alıyoruz.',
      pillars: [
        { number: '01', title: 'Müşteri odağı', text: 'İhtiyacı doğru anlayan, şeffaf ve uzun soluklu iş birlikleri.' },
        { number: '02', title: 'İnsan ve güvenlik', text: 'Gelişimi destekleyen, güvenli ve saygılı çalışma kültürü.' },
        { number: '03', title: 'Sürekli gelişim', text: 'Teknoloji, verimlilik ve kalite sistemlerinde ölçülebilir ilerleme.' },
        { number: '04', title: 'Sürdürülebilir değer', text: 'Çevreyi ve gelecek nesilleri gözeten sorumlu üretim anlayışı.' },
      ],
    },
    careers: {
      eyebrow: 'Kariyer',
      title: '750+ kişilik ekibimizle birlikte büyüyoruz.',
      description:
        'Merak eden, sorumluluk alan ve ürettiği işle iz bırakmak isteyen yeteneklerle tanışmak istiyoruz.',
      cta: 'Bizimle iletişime geçin',
      note: 'Açık pozisyon ve başvuru süreci yakında bu alanda yayınlanacaktır.',
    },
    contact: {
      eyebrow: 'İletişim',
      title: 'Yeni fikirler ve güçlü iş birlikleri için buradayız.',
      addressLabel: 'Merkez ofis',
      address: 'Organize Sanayi Bölgesi, 1. Sokak, No:13 Haspolat / Lefkoşa',
      phoneLabel: 'Telefon',
      phone: '+90 392 444 07 07',
      emailLabel: 'E-posta',
      email: 'info@kamacioglugroup.com',
      formTitle: 'Bize mesaj bırakın',
      formNote: 'Form gönderim altyapısı, paylaşacağınız bilgilerle aktive edilecektir.',
      name: 'Ad Soyad',
      emailField: 'E-posta adresi',
      phoneField: 'Telefon',
      message: 'Mesajınız',
      submit: 'Gönderim yakında aktif',
    },
    footer: 'Kamacıoğlu Şirketler Grubu. Tüm hakları saklıdır.',
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      companies: 'Companies',
      quality: 'Quality',
      careers: 'Careers',
      contact: 'Contact',
    },
    hero: {
      eyebrow: 'From Northern Cyprus to the future',
      title: 'We create together and build lasting value.',
      description:
        'From construction and energy to glass technologies and living spaces, our connected ecosystem creates sustainable value.',
      explore: 'Explore our network',
      contact: 'Contact us',
      networkLabel: 'Companies and brands network',
      networkHint: 'Select a logo to discover its field of expertise.',
    },
    stats: [
      { value: '9', label: 'Group companies' },
      { value: '750+', label: 'Employees' },
      { value: '50+', label: 'Completed large-scale development projects' },
    ],
    about: {
      eyebrow: 'Rooted experience, shared future',
      title: 'We unite different fields of expertise around one vision.',
      lead:
        'Kamacıoğlu Group brings together complementary businesses under one strong culture, contributing to the economic and social development of Northern Cyprus.',
      visionTitle: 'Our vision',
      vision: 'To make our distinctive strengths permanent and move forward on the path to becoming a global brand.',
      missionTitle: 'Our mission',
      mission:
        'To deliver uncompromising quality across every field in which we operate and create sustainable value for our customers, employees and society.',
      valuesTitle: 'Values that connect us',
      values: ['Trust', 'Continuous growth', 'People first', 'Social responsibility'],
    },
    companies: {
      eyebrow: 'Connected ecosystem',
      title: 'One centre, many fields of expertise.',
      description:
        'Our companies and represented brands share knowledge, experience and resources to deliver stronger solutions.',
      visit: 'Visit website',
      profile: 'Group profile',
    },
    quality: {
      eyebrow: 'Our quality approach',
      title: 'Quality is not an outcome. It is how we work.',
      description:
        'We treat safety, environmental responsibility and continuous improvement as inseparable parts of the same standard.',
      pillars: [
        { number: '01', title: 'Customer focus', text: 'Transparent, lasting partnerships built on a clear understanding of needs.' },
        { number: '02', title: 'People and safety', text: 'A safe, respectful culture that supports professional growth.' },
        { number: '03', title: 'Continuous improvement', text: 'Measurable progress in technology, efficiency and quality systems.' },
        { number: '04', title: 'Sustainable value', text: 'Responsible production that considers the environment and future generations.' },
      ],
    },
    careers: {
      eyebrow: 'Careers',
      title: 'We grow together with a team of 750+ people.',
      description:
        'We want to meet curious, accountable people who want their work to leave a lasting mark.',
      cta: 'Get in touch',
      note: 'Open roles and the application process will be published here soon.',
    },
    contact: {
      eyebrow: 'Contact',
      title: 'We are here for new ideas and strong partnerships.',
      addressLabel: 'Head office',
      address: 'Organised Industrial Zone, 1st Street, No:13 Haspolat / Nicosia',
      phoneLabel: 'Phone',
      phone: '+90 392 444 07 07',
      emailLabel: 'Email',
      email: 'info@kamacioglugroup.com',
      formTitle: 'Leave us a message',
      formNote: 'Form delivery will be activated when the integration details are provided.',
      name: 'Full name',
      emailField: 'Email address',
      phoneField: 'Phone',
      message: 'Your message',
      submit: 'Submission coming soon',
    },
    footer: 'Kamacıoğlu Group. All rights reserved.',
  },
} as const
